import { IndexRoute, Router, Route } from 'react-router';
import App from 'noc/app';
import Tickets from 'noc/tickets';

const routes = (
    <Route path="/" component={App} >
        <IndexRoute component={Tickets} />
        <Route path="tickets" component={Tickets} />
        <Route path="*" component={Tickets} />
    </Route>
);

export default function AppRouter(history) {
    return (
        <Router history={history}>
            {routes}
        </Router>
    );
}



// WEBPACK FOOTER //
// ./app/router.jsx